
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import Settingup from './store/_settingup.mdx';
import Storecustomisation from './store/_storecustomisation.mdx';
import Advancedfeatures from './store/_advancedfeatures.mdx';
import Growingstore from './store/_growingstore.mdx';
import Scaling from './store/_scaling.mdx';
import TemplatesCards from '@/Shared/TemplatesCard';
import Cta from '@/partials/Cta';
const Layout = require('@/layouts/RootFileLayout').RootFileLayout;
const meta = {
  "title": "Free Online Store Builder: How to Launch Online Store in Kuwait - 2024",
  "date": "2024-10-28",
  "meta_description": "Launch in Kuwait online store with Tradly's amazingly simple Builder - Free + multiple tools integrated!"
};
const slug = 'kuwait';
const tableOfContents = [{
  "title": "Payment Gateways available for Kuwait",
  "slug": "payment-gateways-available-for-kuwait",
  "children": []
}, {
  "title": "Setting Up Platform",
  "slug": "setting-up-platform",
  "children": []
}, {
  "title": "Customising Platform",
  "slug": "customising-platform",
  "children": []
}, {
  "title": "Advanced Features",
  "slug": "advanced-features",
  "children": []
}, {
  "title": "Growing your Platform",
  "slug": "growing-your-platform",
  "children": []
}, {
  "title": "Scaling your Platform",
  "slug": "scaling-your-platform",
  "children": []
}, {
  "title": "Why Tradly?",
  "slug": "why-tradly",
  "children": []
}];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = require('@/layouts/CustomContentsLayout').CustomContentsLayout
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <p>{`Welcome to Tradly, your all in one toolkit for launching your own online store(Also marketplaces, booking platforms, crowdfunding platform,  directories, etc with no-code) in Kuwait. If you are looking to start an online store but dont know where to begin, we have got you covered.`}</p>
    <p>{`Creating an online store with Tradly is simple and straightforward. Here’s a step-by-step guide to getting started:`}</p>
    <ol {...{
      "role": "list"
    }}>
      <li parentName="ol">{`Sign up for an account
Visit our website and sign up for a free account. You’ll need to provide some basic information, including your name, email address, and preferred password.`}</li>
    </ol>
    <p><_Link href="/signup" passHref><a>{`Signup`}</a></_Link></p>
    <div class="relative">
        <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/signup-tradly.png" />
    </div>
    <TemplatesCards category_id={4283} title={'Free Online Store Templates'} isShowBtn={true} mdxType="TemplatesCards" /> 
    <ol {...{
      "start": 2,
      "role": "list"
    }}>
      <li parentName="ol">
        <p parentName="li">{`Customize your store: Use our simple editor to customize your store’s design and layout. You can choose from a high quality picked templates to launch your online presence without much of building process. Simple to edit branding. And simple to activate or deactivate features. `}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Add your products: Use our easy-to-use product management system to add your products and set their prices. Add product images, descriptions, and other custom fields informations.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Set up your payment gateway: We’ve implemented TAP, a leading payment gateway in Kuwait, to make it easy for you to accept payments online. Simply connect your TAP account to your store, and you’re ready to start accepting payments.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Launch your store: Once you’re happy with your store’s design, layout, and products, it’s time to launch! Click the “publish” button to make your store live and start promoting it to your audience.`}</p>
      </li>
    </ol>
    <p>{`At Tradly, we’re committed to making it easy for you to start and grow your online store. We offer extensive support and resources to help you every step of the way, from creating your store to managing your orders and growing your business.`}</p>
    <p>{`Thank you for choosing Tradly as your partner in launching your online store in Kuwait. We look forward to helping you achieve your goals and grow your business.`}</p>
    <Cta mdxType="Cta" />
  
    <_Heading level={2} id={"payment-gateways-available-for-kuwait"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>Payment Gateways available for Kuwait</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.tap.company/"
        }}>{`TAP`}</a></li>
    </ul>
    <p>{`This is for your users convenience, but if you want to save the transactional cost, you can enable simple cash on delivery or pick up at store approach. `}</p>
    <_Heading level={2} id={"setting-up-platform"} nextElement={{
      "type": "jsx"
    }}>Setting Up Platform</_Heading>
    <Settingup mdxType="Settingup" />
    <_Heading level={2} id={"customising-platform"} nextElement={{
      "type": "jsx"
    }}>Customising Platform</_Heading>
    <Storecustomisation mdxType="Storecustomisation" />
    <_Heading level={2} id={"advanced-features"} nextElement={{
      "type": "jsx"
    }}>Advanced Features</_Heading>
    <Advancedfeatures mdxType="Advancedfeatures" />
    <_Heading level={2} id={"growing-your-platform"} nextElement={{
      "type": "jsx"
    }}>Growing your Platform</_Heading>
    <Growingstore mdxType="Growingstore" />
    <_Heading level={2} id={"scaling-your-platform"} nextElement={{
      "type": "jsx"
    }}>Scaling your Platform</_Heading>
    <Scaling mdxType="Scaling" />
    <_Heading level={2} id={"why-tradly"} nextElement={{
      "type": "paragraph"
    }}>Why Tradly?</_Heading>
    <p>{`Tradly provides all the requirements. `}</p>
    <p>{`According to the council, the stores that have received a registration certificate must implement the following 13 standards of reliability in e-commerce, `}</p>
    <ol {...{
      "role": "list"
    }}>
      <li parentName="ol">
        <p parentName="li">{`Have a contact number for communication (You can add this details in your footer)`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Have an email (Support Page Available or you can create any custom pages)`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Provide a chat option (You can easily activate whatsapp, messagenger or other chats available in `}<a parentName="p" {...{
            "href": "Integratations"
          }}>{`https://tradly.app/integrations`}</a>{`)`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Provide secure electronic payment through official banking channels (TAP : we have implemented TAP, a leading payment gateway in Kuwait. TAP allows us to accept a variety of payment methods, including credit and debit cards, and digital wallets like Apple Pay and Samsung Pay. `}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Enable the consumer to lodge a complaint online; (Use Feedback Page pre-built in your website template)`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Enable the consumer to lodge a complaint via social media;(Your social media pages. And you can add your social media pages in the footer section)`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Disclose the exact time to respond to a complaint.(Add this details in FAQ page)`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Disclose the exact time for processing a complaint; (Add this details in FAQ page)`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Disclose the exact time of delivery before completing the purchase and indicate this information in the invoice;(Add this details in FAQ page)`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`The store supports the Arabic language as an option for filing a complaint; (Arabic is supported in all templates)`}</p>
      </li>
    </ol>
    <p>{`11 Use Arabic in chat; (Yourside customer Service)`}</p>
    <ol {...{
      "start": 12,
      "role": "list"
    }}>
      <li parentName="ol">
        <p parentName="li">{`Display products in Arabic (Available)`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Have a clear and written return or refund policy.(Add this details in FAQ page)`}</p>
      </li>
    </ol>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
